import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "../../Components/Modal";
import { addgastengebruik, addgasten } from "./Reducers/actions";
import { fetchkampeerplaatsen, fetchaccommodaties } from "../Standplaatsen/Reducers/actions";
import InsertForm from "./Components/insert";
import Insertgast from "./Components/insertgast";

const KampeerplaatsEditPage = ({ fetchaccommodaties, addgastengebruik, kampeerplaatsen, fetchkampeerplaatsen, addgasten, accommodaties, bedrijf }) => {
  const [loaded, setLoaded] = useState(false);
  const [visible, setVisible] = useState(false);
  const [gastid, setGastId] = useState(null);
  const [emailadres, setEmailadres] = useState("");
  const [gastdata, setGastdata] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const submit = (vals) => {
    delete vals["data"];
    addgastengebruik(vals).then((data) => {
      if (data.type === "SENSOR_ERROR") {
        return false;
      } else {
        navigate("/gastenverbruik/");
      }
    });
  };
  const submitgast = (vals) => {
    setLoading(true);
    setError(null);

    addgasten(vals).then((data) => {
      setLoading(false);
      if (data.type === "GASTEN_VERBRUIK_ERROR") {
        const errorMessage = data.error?.data?.global ||
                           data.error?.message ||
                           "Er is een onbekende fout opgetreden";
        setError(errorMessage);
        return false;
      } else {
        setGastId(data.results.result);
        setVisible(false);
        setError(null);
      }
    }).catch((err) => {
      setLoading(false);
      setError("Er is een fout opgetreden bij het opslaan van de gast");
    });
  };
  const OpenmMdal = (val) => {
    setVisible(val);
  };
  useEffect(() => {
    fetchkampeerplaatsen().then(() => {
      fetchaccommodaties().then(() => {
        setLoaded(true);
      });
    });
  }, [loaded]);
  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title"> Reservering toevoegen</h3>
      </div>

      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              {loaded && <InsertForm setGastdata={(value) => setGastId(value)}  emailadres={(value) => setEmailadres(value)} bedrijf={bedrijf} gast={gastid} onSubmit={submit} standplaatsen={kampeerplaatsen} accommodaties={accommodaties} OpenmMdal={OpenmMdal} />}
            </div>
          </div>
        </div>
      </div>
      <Modal
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        width={600}
      >
        <div className="box box-default">
          <div className="row">
            <div className="col-md-12  col-sm-12">
              <div className="box-title">
                <h3>Maak een nieuwe gast aan</h3>
              </div>

              <div className="box-body">
                {error && (
                  <div className="alert alert-danger alert-dismissible">
                    <button type="button" className="close" onClick={() => setError(null)} aria-hidden="true">×</button>
                    <h4><i className="icon fa fa-ban"></i> Fout!</h4>
                    {error}
                  </div>
                )}
                <Insertgast onSubmit={submitgast} emailadres={emailadres} loading={loading} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  bedrijf: state.auth.user.bedrijf,
  kampeerplaatsen: state.standplaatsen.kampeerplaatsen,
  accommodaties: state.standplaatsen.accommodaties,
});

export default connect(mapStateToProps, { addgastengebruik, fetchkampeerplaatsen, addgasten, fetchaccommodaties })(KampeerplaatsEditPage);
